import { gql } from "@apollo/client";

export const getCoderAssignmentConfig = gql`
  query CoderAssignmentConfig($service: String){
    CoderAssignmentConfig(service: $service)
  }
`;